import api from '@/services/api';
import { WE_CHANNEL, WE_APP_ID, APP_SECRET } from '@/config'
import { base64Encode, randNumber } from '@/utils'
import md5 from 'md5'

const SERVER = {
  newRegisterUrl: '/official/appointment/register'
};
// 预约专业顾问回访
export function register(params) {
  const trace_id = new Date().getTime() + randNumber(8)
  const token = md5(WE_APP_ID + trace_id + base64Encode(JSON.stringify(params)) + APP_SECRET)
  return api.post(SERVER.newRegisterUrl, params, {
    headers: {
      'Content-Type': 'application/json',
      'WE-APP-ID': WE_APP_ID,
      'WE-TRACE-ID': trace_id,
      'WE-CHANNEL': WE_CHANNEL,
      'WE-TOKEN': token
    }
  }).then(res => {
    return res.data;
  });
}

export default {
  register
};
